import * as React from 'react';
import { useState, useEffect } from 'react';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import Button from '../../../../common/form/Button';
import { userIsCompanyManageUser, userIsPropertyManageUser, userIsSystemManageUser } from '../../../../../utilities/identity';

const isUser = (
    userIsCompanyManageUser() ||
    userIsPropertyManageUser() ||
    userIsSystemManageUser()
);

interface Props {
    onKeyAdd: (newKeyId: string, type: string) => Promise<void>;
    resetTrigger: number;
}

const NewLatchKeyRow = (props: Props) => {
    const [newKeyId, setNewKeyId] = useState('');
    const [type, setNewType] = useState('latch-m');
    useEffect(() => {
        setNewKeyId('');
    }, [props.resetTrigger])
    return (
        <Row className="code-row">
            <Col>
                <input
                    className="form-control"
                    value={newKeyId}
                    placeholder="New Key ID..."
                    onChange={changeEvent => setNewKeyId(changeEvent.target.value)}
                    disabled={isUser}
                />
            </Col>
            <Col md={3}>
                <select
                    value={type}
                    className='form-control'
                    onChange={changeEvent => setNewType(changeEvent.target.value)}
                    disabled={isUser}
                >
                    <option value="unit">Unit</option>
                    <option value="building">Building</option>
                    <option value="both">Both</option>
                </select>
            </Col>
            <Col md={2}>
                <Button
                    addlClassName='btn-sm btn-primary'
                    text="Add"
                    onClick={() => props.onKeyAdd(newKeyId, type)}
                    suppressBottomMargin={true}
                    disabled={isUser}
                />
            </Col>
        </Row>
    );
};

export default NewLatchKeyRow;



// WEBPACK FOOTER //
// ./src/components/pages/admin/editProperty/integrationControls/NewLatchKeyRow.tsx